import React from 'react';

const PremiosConTexto = (props) => {
  const { premios } = props.yearData;

  const formatPremio = (premio, index) => {
    // Mantienes la lógica de no tocar el 1er (index 0) y 3er (index 2) premio
    if (index === 0 || index === 2) {
      return <p key={index}>{premio}</p>;
    }

    let icon = '';
    let color = 'inherit';
    const lowerPremio = premio.toLowerCase().trim();

    if (lowerPremio.startsWith('millor') || premio.includes('1º')) {
      icon = '🥇';
      color = '#DAA520'; // dorado oscuro
    } else if (premio.includes('2º')) {
      icon = '🥈';
      color = '#A1A1A1'; // plateado
    } else if (premio.includes('3º')) {
      icon = '🥉';
      color = '#8C4700'; // bronce más oscuro
    }

    return (
      <p key={index} style={{ color, fontWeight: icon ? 'bold' : 'normal' }}>
        {icon && `${icon} `}{premio}
      </p>
    );
  };

  return (
    <div className='numero-premios'>
      <h2>{props.I18n.AwardsHistory}</h2>

      {/* Nuevo contenedor para la lista de premios */}
      <div className="premios-lista">
        {premios.map((premio, index) => formatPremio(premio, index))}
      </div>

      <hr />
    </div>
  );
};

export default PremiosConTexto;
